import React, { Component } from 'react'
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import API from './../../config/api';
import httpRequest from '@/utils/httpRequest'
import './index.scss'
import Header from '@/components/Header/header'
import AppBtn from '@/components/AppBtn/appBtn'

// 基地活动和所站活动
export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      type:'', // 1:基础活动  其他为所站活动
      uuid:'', // 活动uuid
      data:{
        activity:{}
      },
    }
  }

  componentDidMount(){
    // 获取对应参数 
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      type:parameter.type,
      uuid:parameter.uuid,
      base_id:parameter.base_id,
    },() => {
      if(!this.state.uuid){
        // 获取活动基础信息
        this.getBaseInfo()
      } else {
        // 获取列表 
        this.getList()
      }
    })
  }

  getList = () => {
    const {type,uuid} = this.state
    let url = ''
    let data = {}
    if(type / 1 === 1){
      // 获取基础活动
      url = API.baseActivityDetail
      data.activity_uuid = uuid 
    } else{
      // 获取所站活动
      url = API.stationActivityDetail
      data.uuid = uuid 
    }
    httpRequest({
      url: url,
      type: 'get',
      data: data
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  getBaseInfo = () => {
    const {base_id} = this.state
    httpRequest({
      url: API.practiceBaseDetail,
      type: 'get',
      data: {
        base_id:base_id
      }
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  render() {
    const {data,type,uuid} = this.state
    return (
      <div>
      {/*头部*/}
			<Header name={'home'} uuid={''}/>
        <div className='activityContainer'>
        {type / 1 === 1 ? // 基地活动详情
          <div>
            {uuid?
              <div className="cover"><img src={data.cover} alt=""/></div>
            :''}
            <div className="info">
              <div className="title">{data.activity_name}</div>
              {uuid ? 
                <div className="desc">{data.introduce}</div>
              :
                <div dangerouslySetInnerHTML={{
                      __html: data.info
                }}/>
              }
            </div>
            {data.address ?
              <div className="module">
                <div className="title">基地地址</div>
                <div className="content">{data.address}</div>
              </div>
            :''}
            {data.activity_info && data.activity_info.title ?
              <div className="module">
                <div className="title">活动标题</div>
                <div className="content">{data.activity_info.title}</div>
              </div>
            :''}
            {data.activity_info && data.activity_info.start_time && data.activity_info.end_time ? 
              <div className="module">
                <div className="title">活动时间</div>
                <div className="content">
                  {data.activity_info.start_time} 至 {data.activity_info.end_time}
                </div>
              </div>
            :''}
            {data.activity_info && data.activity_info.join_end_time ?
              <div className="module">
                <div className="title">报名截止时间</div>
                <div className="content">
                  { data.activity_info.join_end_time }
                </div>
              </div>
            :''}
            {data.activity_info && data.activity_info.num_limit ? 
              <div className="module">
                <div className="title">活动名额</div>
                <div className="content">
                  {data.activity_info.num_limit}人
                </div>
              </div>
            :''}
            {data.activity_info && data.activity_info.join_num?
              <div className="module">
                <div className="title">已报名人数</div>
                <div className="content">
                  {data.activity_info.join_num}人
                </div>
              </div>
            :''}
            {data.activity_info && data.activity_info.mobile?
              <div className="module">
                <div className="title">联系电话</div>
                <div className="content">
                  {data.activity_info.mobile}
                </div>
              </div>
            :''}
            {data.activity_info && data.activity_info.arrange?
              <div className="module">
                <div className="title">活动安排</div>
                <div className="content">
                  {data.activity_info.arrange}
                </div>
              </div>
            :''}
          </div>
        : // 所站活动详情
          <div>
            <div className="cover"><img src={data.cover} alt=""/></div>
            <div className="info">
              <div className="title">{data.title}</div>
              {/* <div className="desc">{data.info}</div> */}
            </div>
            {data.place ?
              <div className="module">
                <div className="title">活动地址</div>
                <div className="content">{data.place}</div>
              </div>
            :''}
            {data.start_time ? 
              <div className="module">
                <div className="title">活动开始时间</div>
                <div className="content">{data.start_time}</div>
              </div>
            :''}
            {data.end_time ? 
              <div className="module">
                <div className="title">活动结束时间</div>
                <div className="content">{data.end_time}</div>
              </div>
            :''}
            {data.join_end_time ?
              <div className="module">
                <div className="title">报名截止时间</div>
                <div className="content">
                  { data.join_end_time }
                </div>
              </div>
            :''}
            {data.num_limit ? 
              <div className="module">
                <div className="title">活动名额</div>
                <div className="content">
                  {data.num_limit}人
                </div>
              </div>
            :''}
            { data.join_num?
              <div className="module">
                <div className="title">已报名人数</div>
                <div className="content">
                  {data.join_num}人
                </div>
              </div>
            :''}
            { data.mobile?
              <div className="module">
                <div className="title">联系电话</div>
                <div className="content">
                  {data.mobile}
                </div>
              </div>
            :''}
            { data.info?
              <div className="module">
                <div className="title">活动介绍</div>
                <div className="content">
                  {data.info}
                </div>
              </div>
            :''}
          </div>
        }
        <AppBtn name={'home'} uuid={''} text={`去东城APP打开`}/>
      </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/CivilizationActivityDetail/index.js